<div class="modal inmodal fade in mailing-result-modal" [ngClass]="{'show': showModal}">
    <div class="modal-dialog ">
        <div class="modal-content">
            <button type="button" class="close" (click)="hideModal()">
                <span>×</span><span class="sr-only">Close</span>
            </button>
            <div class="flex">
                <div class="left-part col-sm-3">
                    <div class="title">Filter Recipient List</div>
                    <div class="filters-box">
                        <div class="filter m-b-sm">
                            <div class="img-checkbox building-checkbox">
                                <input type="checkbox" id="statuses" [ngModel]="sf.isAllStatusChecked()"
                                       (change)="sf.toggleCheckedAll($event.target.checked)">
                                <label for="statuses">
                                    <svg-checked></svg-checked>
                                    <svg-halfchecked></svg-halfchecked>
                                    <span>Status</span>
                                    <i class="fa {{sf.showDropdown ? 'fa-chevron-up' : 'fa-chevron-down'}}"
                                       (click)="sf.showDropdown = !sf.showDropdown; $event.preventDefault();">
                                    </i>
                                </label>
                            </div>
                            <div class="filter-dropdown" *ngIf="sf.showDropdown">
                                <div class="clearfix" *ngFor="let s of sf.statuses;">
                                    <div class="col-sm-10">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="sf-{{s}}" [(ngModel)]="sf[s]">
                                            <label for="sf-{{s}}">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>{{sf.getLabel(s)}}</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <span>{{sf.getUsersCountByStatus(s)}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="filter m-b-sm" *ngFor="let item of data.filtersList; let i = index;">
                            <div class="img-checkbox building-checkbox">
                                <input type="checkbox" id="building-{{i}}" disabled checked
                                       [class.halfchecked]="isBuildingHalfChecked(item)">
                                <label for="building-{{i}}">
                                    <svg-checked></svg-checked>
                                    <svg-halfchecked></svg-halfchecked>
                                    <span>{{item.buildingName}}</span>
                                </label>
                            </div>
                            <div class="filter-dropdown">
                                <div class="clearfix" [class.hidden]="!item.tenantsChecked && !item.ownerOnChecked">
                                    <div class="col-sm-10">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="b-{{i}}-residents" disabled checked
                                                   [class.halfchecked]="isResidentHalfChecked(item)">
                                            <label for="b-{{i}}-residents">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>Residents</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <!--<span>{{item.tenantsCount + item.ownerOnCount}}</span>-->
                                    </div>
                                </div>
                                <div class="clearfix" [class.hidden]="!item.tenantsChecked || !item.tenantsCount">
                                    <div class="col-sm-10 pl-for-residents">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="b-{{i}}-tenants" disabled checked
                                                   [class.halfchecked]="item.tenantsHalfChecked">
                                            <label for="b-{{i}}-tenants">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>Tenants</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <span>{{item.tenantsCount}}</span>
                                    </div>
                                </div>
                                <div class="clearfix" [class.hidden]="!item.ownerOnChecked || !item.ownerOnCount">
                                    <div class="col-sm-10 pl-for-residents">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="b-{{i}}-owner-on" disabled checked
                                                   [class.halfchecked]="item.ownerOnHalfChecked">
                                            <label for="b-{{i}}-owner-on">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>Owners (On-Site)</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <span>{{item.ownerOnCount}}</span>
                                    </div>
                                </div>
                                <div class="clearfix" [class.hidden]="!item.ownerOffChecked || !item.ownerOffCount">
                                    <div class="col-sm-10">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="b-{{i}}-owner-off" disabled checked
                                                   [class.halfchecked]="item.ownerOffHalfChecked">
                                            <label for="b-{{i}}-owner-off">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>Owners (Off-Site)</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <span>{{item.ownerOffCount}}</span>
                                    </div>
                                </div>
                                <div class="clearfix" [class.hidden]="!item.residentOwnerChecked || !item.residentOwnerCount">
                                    <div class="col-sm-10">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="b-{{i}}-resident-owner" disabled checked
                                                   [class.halfchecked]="item.residentOwnerHalfChecked">
                                            <label for="b-{{i}}-resident-owner">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>Resident Owner</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <span>{{item.residentOwnerCount}}</span>
                                    </div>
                                </div>
                                <div class="clearfix" [class.hidden]="!item.residentOnlyNotOnDeedChecked || !item.residentOnlyNotOnDeedCount">
                                    <div class="col-sm-10">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="b-{{i}}-resident-only-not-on-deed" disabled checked
                                                   [class.halfchecked]="item.residentOnlyNotOnDeedHalfChecked">
                                            <label for="b-{{i}}-resident-only-not-on-deed">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>Resident Only Not On Deed</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <span>{{item.residentOnlyNotOnDeedCount}}</span>
                                    </div>
                                </div>
                                <div class="clearfix" [class.hidden]="!item.ownerFamilyChecked || !item.ownerFamilyCount">
                                    <div class="col-sm-10">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="b-{{i}}-owner-family" disabled checked
                                                   [class.halfchecked]="item.ownerFamilyHalfChecked">
                                            <label for="b-{{i}}-owner-family">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>Owner Family</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <span>{{item.ownerFamilyCount}}</span>
                                    </div>
                                </div>
                                <div class="clearfix" [class.hidden]="!item.guestChecked || !item.guestCount">
                                    <div class="col-sm-10">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="b-{{i}}-guest" disabled checked
                                                   [class.halfchecked]="item.guestHalfChecked">
                                            <label for="b-{{i}}-guest">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>Guest</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <span>{{item.guestCount}}</span>
                                    </div>
                                </div>
                                <div class="clearfix" [class.hidden]="!item.offsiteResidentChecked || !item.offsiteResidentCount">
                                    <div class="col-sm-10">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="b-{{i}}-offsite-resident" disabled checked
                                                   [class.halfchecked]="item.offsiteResidentHalfChecked">
                                            <label for="b-{{i}}-offsite-resident">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>Offsite Resident</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <span>{{item.offsiteResidentCount}}</span>
                                    </div>
                                </div>
                                <div class="clearfix" [class.hidden]="!item.residentChecked || !item.residentCount">
                                    <div class="col-sm-10">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="b-{{i}}-resident" disabled checked
                                                   [class.halfchecked]="item.residentHalfChecked">
                                            <label for="b-{{i}}-resident">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>Resident</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <span>{{item.residentCount}}</span>
                                    </div>
                                </div>
                                <div class="clearfix" [class.hidden]="!item.occupantChecked || !item.occupantCount">
                                    <div class="col-sm-10">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="b-{{i}}-occupant" disabled checked
                                                   [class.halfchecked]="item.notSetHalfChecked">
                                            <label for="b-{{i}}-occupant">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>Occupant</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <span>{{item.occupantCount}}</span>
                                    </div>
                                </div>
                                <div class="clearfix" [class.hidden]="!item.notSetChecked || !item.notSetCount">
                                    <div class="col-sm-10">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="b-{{i}}-not-set" disabled checked
                                                   [class.halfchecked]="item.notSetHalfChecked">
                                            <label for="b-{{i}}-not-set">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>Not Set</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <span>{{item.notSetCount}}</span>
                                    </div>
                                </div>
                                <div class="clearfix" [class.hidden]="!item.unitManagerChecked || !item.unitManagerCount">
                                  <div class="col-sm-10">
                                      <div class="img-checkbox">
                                          <input type="checkbox" id="b-{{i}}-unit-manager" disabled checked
                                                 [class.halfchecked]="item.unitManagerChecked">
                                          <label for="b-{{i}}-unit-manager">
                                              <svg-checked></svg-checked>
                                              <svg-halfchecked></svg-halfchecked>
                                              <span>Unit Manager</span>
                                          </label>
                                      </div>
                                  </div>
                                  <div class="col-sm-2 text-right">
                                      <span>{{item.unitManagerCount}}</span>
                                  </div>
                                </div>
                                <hr>
                                <div class="clearfix" *ngFor="let group of item.groups; let i_g = index;"
                                     [class.hidden]="!group.count">
                                    <div class="col-sm-10">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="b-{{i}}-group-{{i_g}}" disabled checked
                                                   [class.halfchecked]="group.halfchecked">
                                            <label for="b-{{i}}-group-{{i_g}}">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>{{group.name}}</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <span>{{group.count}}</span>
                                    </div>
                                </div>
                                <hr *ngIf="!(!item.staffChecked || !item.staffCount)">
                                <div class="clearfix" [class.hidden]="!item.staffChecked || !item.staffCount">
                                    <div class="col-sm-10">
                                        <div class="img-checkbox">
                                            <input type="checkbox" id="b-{{i}}-staff" disabled checked
                                                   [class.halfchecked]="item.staffHalfChecked">
                                            <label for="b-{{i}}-staff">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                                <span>Staff</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 text-right">
                                        <span>{{item.staffCount}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-part col-sm-9">
                    <div class="head">
                        <div class="search-box">
                            <input [(ngModel)]="sf.searchStr" placeholder="Search">
                            <i class="fa fa-search" *ngIf="!sf.searchStr"></i>
                            <i class="fa fa-times"  *ngIf="sf.searchStr" (click)="sf.searchStr = ''"></i>
                            <i class="fa fa-question mtv-primary-color" aria-hidden="true"
                               (click)="es.showSearchInstructionsModal = true;"></i>
                        </div>
                        <div class="input-group-btn pull-right m-r-md" style="right: 30px;">
                            <button class="btn btn-w-s btn-primary pull-right"
                                    style="border-radius: 3px 0 0 3px;"
                                    type="button"
                                    (click)="printEmailInfo(true)">
                                Print
                            </button>
                            <button data-toggle="dropdown" class="btn btn-primary dropdown-toggle" type="button"
                                    aria-expanded="false">
                                <span class="caret"></span>
                            </button>
                            <ul class="dropdown-menu pull-right" style="right: -25px;">
                                <li (click)="printEmailInfo(false)"><a>View As HTML</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="table-box">
                        <table class="table table-striped table-hover footable">
                            <thead>
                            <tr>
                                <th (click)="orderBy('suiteName', $event)">Unit<span class="footable-sort-indicator"></span></th>
                                <th (click)="orderBy('buildingName', $event)">Building<span class="footable-sort-indicator"></span></th>
                                <th (click)="orderBy('name', $event)">Resident<span class="footable-sort-indicator"></span></th>
                                <th (click)="orderBy('type', $event)">Type<span class="footable-sort-indicator"></span></th>
                                <th>Email</th>
                                <th (click)="orderBy('status', $event)" class="footable-sorted">Status<span class="footable-sort-indicator"></span></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let item of sf.filterResidents(); let i = index;">
                                <td>{{item.suiteName || '-'}}</td>
                                <td>{{item.buildingName}}</td>
                                <td>{{item.name}}</td>
                                <td>
                                    {{ item.humanReadableType() }}
                                </td>
                                <td>{{item.email}}</td>
                                <td>
                                    <span *ngIf="item.status === 'in_progress'"
                                          class="text-uppercase label label-in-progress">
                                        In Progress
                                    </span>
                                    <span *ngIf="item.status === 'sent'"
                                          class="text-uppercase label label-{{item.status}}">
                                        Unread
                                    </span>
                                    <span *ngIf="item.status !== 'in_progress' && item.status !== 'sent'"
                                          class="text-uppercase label label-{{item.status}}">
                                        {{item.status}}
                                    </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <search-instructions-modal *ngIf="es.showSearchInstructionsModal"></search-instructions-modal>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>




// WEBPACK FOOTER //
// /app/src/app/views/email/mailing-result-modal/mailing-result-modal.component.html